import React, { useState } from 'react';
import Cards from 'react-credit-cards-2';
import 'react-credit-cards-2/dist/es/styles-compiled.css';
import './styles/creditcard.css';

const CreditCardForm = ({ onSubmit, showInvoiceFields = false }) => {
  const [state, setState] = useState({
    number: '',
    name: '',
    expiry: '',
    cvc: '',
    focus: '',
    email: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    // Invoice-specific fields
    invoiceNumber: '',
    amount: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'expiry') {
      // Remove any non-numeric characters
      let numericValue = value.replace(/\D/g, '');

      // Limit to 4 digits
      numericValue = numericValue.slice(0, 4);

      // Validate month (01-12)
      if (numericValue.length >= 2) {
        let month = numericValue.slice(0, 2);
        if (parseInt(month) > 12) {
          month = '12';
        }
        if (parseInt(month) < 1 && numericValue.length === 2) {
          month = '01';
        }
        numericValue = month + numericValue.slice(2);
      }

      // Format as MM/YY
      let formattedValue = numericValue;
      if (numericValue.length >= 2) {
        formattedValue = numericValue.slice(0, 2) + '/' + numericValue.slice(2);
      }

      setState(prev => ({
        ...prev,
        [name]: formattedValue
      }));
    } else if (name === 'number') {
      // Format card number with spaces
      let numericValue = value.replace(/\D/g, '');
      let formattedValue = numericValue.replace(/(\d{4})(?=\d)/g, '$1 ');

      setState(prev => ({
        ...prev,
        [name]: formattedValue
      }));
    } else {
      setState(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleInputFocus = (e) => {
    setState(prev => ({ 
      ...prev, 
      focus: e.target.name 
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(state);
  };

  return (
    <div className="credit-card-form">
      <div className="credit-card-container">
        <Cards
          number={state.number}
          name={state.name}
          expiry={state.expiry}
          cvc={state.cvc}
          focused={state.focus}
        />
      </div>
      <form onSubmit={handleSubmit}>
        {/* Invoice-specific fields */}
        {showInvoiceFields && (
          <>
            <div className="form-group">
              <label>Invoice Details</label>
            </div>
            <div className="form-row">
              <div className="form-group">
                <input
                  type="text"
                  name="invoiceNumber"
                  placeholder="INV-001234"
                  value={state.invoiceNumber}
                  onChange={handleInputChange}
                  onFocus={handleInputFocus}
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="number"
                  name="amount"
                  placeholder="Number Amount"
                  value={state.amount}
                  onChange={handleInputChange}
                  onFocus={handleInputFocus}
                  step="0.01"
                  min="0"
                  required
                />
              </div>
            </div>
          </>
        )}

        <div className="form-group">
          <input
            type="text"
            name="name"
            placeholder="Cardholder Name"
            value={state.name}
            onChange={handleInputChange}
            onFocus={handleInputFocus}
            required
          />
        </div>
        <div className="form-group">
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={state.email}
            onChange={handleInputChange}
            onFocus={handleInputFocus}
            required
          />
        </div>
        <div className="form-group">
          <input
            type="text"
            name="address"
            placeholder="Address"
            value={state.address}
            onChange={handleInputChange}
            onFocus={handleInputFocus}
            required
          />
        </div>
        <div className="form-row">
          <div className="form-group">
            <input
              type="text"
              name="city"
              placeholder="Parish"
              value={state.city}
              onChange={handleInputChange}
              onFocus={handleInputFocus}
              required
            />
          </div>
          <div className="form-group">
            <input
              type="text"
              name="zip"
              placeholder="ZIP Code"
              value={state.zip}
              onChange={handleInputChange}
              onFocus={handleInputFocus}
              required
            />
          </div>
        </div>

        <div className="form-group">
          <input
            type="tel"
            name="number"
            placeholder="Card Number"
            value={state.number}
            onChange={handleInputChange}
            onFocus={handleInputFocus}
            maxLength="19"
            required
          />
        </div>
        <div className="form-row">
          <div className="form-group expiry">
            <input
              type="text"
              name="expiry"
              placeholder="MM/YY"
              value={state.expiry}
              onChange={handleInputChange}
              onFocus={handleInputFocus}
              maxLength="5"
              required
            />
          </div>
          <div className="form-group cvc">
            <input
              type="tel"
              name="cvc"
              placeholder="CVC"
              value={state.cvc}
              onChange={handleInputChange}
              onFocus={handleInputFocus}
              maxLength="4"
              required
            />
          </div>
        </div>
        <button type="submit" className="submit-button">
          Pay Now
        </button>
      </form>
    </div>
  );
};

export default CreditCardForm;
